/** 各フェーズ定義 */
export const PHASE = {
  INITIAL_WAITING: 'initialWaiting',
  GET_READINESS_CODE: 'getReadinessCode',
  DRIVE_CYCLE_DATA_ACQUISITION: 'driveCycleDataAcquisition',
  EVAPO_LEAK_TEST_FAILURE: 'evapoLeakTestFailure',
  DIAG_CODE_DELETE: 'diagCodeDelete',
  DIAG_CODE_DELETE_SUCCESS: 'diagCodeDeleteSuccess',
  DIAG_CODE_DELETE_FAILURE: 'diagCodeDeleteFailure',
  DATA_MONITOR: 'dataMonitor',
  DATA_MONITOR_STARTED: 'dataMonitorStarted',
  DATA_MONITOR_INTERRUPTION: 'dataMonitorInterruption',
  EVAPO_LEAK_TEST_RESULT: 'evapoLeakTestResult',
  PROJECT_DATA: 'projectData',
  MONITOR_TEST_RESULT: 'monitorTestResult',
  DTC_DISPLAY: 'dtcDisplay',
  READINESS_CODE_DISPLAY: 'readinessCodeDisplay',
  DETAILED_FFD: 'detailedFfd',
  INTERRUPTION: 'interruption',
  COMMUNICATION_ERROR: 'communicationError',
  COMPLETION: 'completion',
  FAILED: 'failed'
};

/**
 * ダイアログ表示関連/ボタン押下時処理
 * @param {instance} self this
 */
export class Dialog {

  constructor(self) {
    this.requirementInstance = self;
    this.phase = PHASE.INITIAL_WAITING;
    this.showButtonMap = {
      Cancel: {
        driveCycleDataAcquisition: true,
        dataMonitorInterruption: true,
        projectData: true,
      },
      Ok: {
        getReadinessCode: true,
        driveCycleDataAcquisition: true,
        diagCodeDeleteSuccess: true,
        dataMonitorInterruption: true,
        evapoLeakTestResult: true,
        detailedFfd: true,
        completion: true,
        interruption: true,
        diagCodeDeleteFailure: true,
        evapoLeakTestFailure: true,
        communicationError: true,
        failed: true,
      },
      No: {
        diagCodeDelete: true
      },
      Yes: {
        diagCodeDelete: true
      },
      Start: {
        dataMonitor: true,
        dataMonitorStarted: true,
      },
      Finish: {
        dataMonitor: true,
        dataMonitorStarted: true,
      },
      Save: {
        projectData: true,
      },
    };
  }

  /** 
   * ダイアログのヘッダカラーkeyを返す
   * @returns {string} ヘッダーカラーkey
   */
  headerColor() {
    switch (this.phase) {
      case PHASE.EVAPO_LEAK_TEST_FAILURE:
      case PHASE.COMMUNICATION_ERROR:
      case PHASE.DIAG_CODE_DELETE_FAILURE:
      case PHASE.FAILED:
        return 'danger';
      case PHASE.DIAG_CODE_DELETE_SUCCESS:
      case PHASE.COMPLETION:
        return 'success';
      default:
        return 'secondary';
    }
  }

  /**
   * ダイアログのヘッダ文言を返す
   * @returns {string} ヘッダ文言
   */
  headerTitle() {
    const ExecutionTitle = this.requirementInstance.$t('individual.common_title_execution');
    const ConfirmationTitle = this.requirementInstance.$t('message.common_title_confirmation');
    const InputTitle = this.requirementInstance.$t('individual.label_input');
    const SuccessTitle = this.requirementInstance.$t('message.common_title_success');
    const FfdTitle = this.requirementInstance.ffdTitle;
    const ErrorTitle = this.requirementInstance.$t('message.common_title_error');
    const titleMap = {
      initialWaiting: ConfirmationTitle,
      getReadinessCode: ConfirmationTitle,
      driveCycleDataAcquisition: ConfirmationTitle,
      evapoLeakTestFailure: ErrorTitle,
      diagCodeDelete: ConfirmationTitle,
      diagCodeDeleteSuccess: SuccessTitle,
      diagCodeDeleteFailure: ErrorTitle,
      dataMonitor: ExecutionTitle,
      dataMonitorStarted: ExecutionTitle,
      dataMonitorInterruption: ExecutionTitle,
      evapoLeakTestResult: ExecutionTitle,
      projectData: InputTitle,
      monitorTestResult: ExecutionTitle,
      dtcDisplay: ExecutionTitle,
      readinessCodeDisplay: ExecutionTitle,
      detailedFfd: FfdTitle,
      interruption: ConfirmationTitle,
      communicationError: ErrorTitle,
      completion: SuccessTitle,
      failed: ErrorTitle,
    };
    return titleMap[this.phase];
  }

  /**
   * ダイアログ表示文言を返す
   * @returns {string} ダイアログ表示文言
   */
  displayInfo() {
    const messageMap = {
      initialWaiting: ``,
      getReadinessCode: this.requirementInstance.$t(this.requirementInstance.dtcStatusAvailabilityMask ?
        `individual.label_readiness_code_compatible_ws45` :    // レディネスコード対応
        `individual.label_readiness_code_not_supported_ws45`), // レディネスコード非対応
      driveCycleDataAcquisition: this.requirementInstance.driveCycleDataResult,
      evapoLeakTestFailure: this.requirementInstance.$t(`individual.label_evapo_leak_test_failure_ws45`),
      diagCodeDelete: this.requirementInstance.$t(`individual.label_diag_code_delete_ws45`),
      diagCodeDeleteSuccess: this.requirementInstance.$t(`individual.label_diag_code_delete_success_ws45`),
      diagCodeDeleteFailure: this.requirementInstance.$t(`individual.label_diag_code_delete_failure_ws45`),
      dataMonitor: this.requirementInstance.$t(`${this.requirementInstance.i18nWsKey}.menu_title`),
      dataMonitorStarted:
        this.requirementInstance.$t(`${this.requirementInstance.i18nWsKey}.menu_title`)
        + "  "
        + "<span style=\"color:red; font-size: large;\">"
        + this.requirementInstance.$t(`individual.common_title_execution`)
        + "..."
        + "</span>",
      dataMonitorInterruption: this.requirementInstance.$t(`individual.label_data_monitor_interruption_ws45`),
      evapoLeakTestResult: this.requirementInstance.evapoLeakTestResult,
      projectData: ``,
      monitorTestResult: ``,
      dtcDisplay: ``,
      readinessCodeDisplay: ``,
      detailedFfd: ``,
      interruption: this.requirementInstance.$t(`individual.label_interruption_ws45`),
      communicationError: this.requirementInstance.$t(`individual.label_data_error_ws45`),
      completion: this.requirementInstance.$t(`individual.label_completion_display_ws45`),
      failed: this.requirementInstance.$t(`individual.error_communication_error`),
    };
    return messageMap[this.phase];
  }

  /**
   * ダイアログに表示するボタン情報を返す
   * @param {string} buttonName ボタン名
   * @returns {boolean} 
   */
  showButton(buttonName) {
    return this.showButtonMap[buttonName][this.phase] ? this.showButtonMap[buttonName][this.phase] : false;
  }

  /**
   * ダイアログサイズを返す
   * @returns {string} ダイアログサイズ
   */
  modalSize() {
    switch (this.phase) {
      case PHASE.DRIVE_CYCLE_DATA_ACQUISITION:
      case PHASE.PROJECT_DATA:
      case PHASE.DTC_DISPLAY:
      case PHASE.MONITOR_TEST_RESULT:
      case PHASE.DETAILED_FFD:
      case PHASE.DIAG_CODE_DELETE:
      case PHASE.READINESS_CODE_DISPLAY:
      case PHASE.DATA_MONITOR:
        return 'lg';
      case PHASE.DATA_MONITOR_STARTED:
        return 'huge';
      default:
        return 'md';
    }
  }

  /**
   * ダイアログ キャンセルボタン押下時処理
   */
  onCancelClicked() {
    switch (this.phase) {
      case PHASE.DRIVE_CYCLE_DATA_ACQUISITION:
        this.requirementInstance.interruptionProcess();
        break;
      case PHASE.DATA_MONITOR_INTERRUPTION:
        this.requirementInstance.startDataMonitor();
        break;
      case PHASE.PROJECT_DATA:
        this.requirementInstance.callSaveCancelled();
        break;
      default:
        break;
    }
  }

  /**
   * ダイアログ OKボタン押下時処理
   */
  onOkClicked() {
    switch (this.phase) {
      case PHASE.GET_READINESS_CODE:
        this.requirementInstance.readDriveCycleData();
        break;
      case PHASE.DRIVE_CYCLE_DATA_ACQUISITION:
        this.requirementInstance.diagCodeDeleteProcess();
        break;
      case PHASE.DIAG_CODE_DELETE_SUCCESS:
        this.requirementInstance.showDataMonitor();
        break;
      case PHASE.DATA_MONITOR_INTERRUPTION:
        this.requirementInstance.terminateDataMonitor();
        break;
      case PHASE.EVAPO_LEAK_TEST_RESULT:
        this.requirementInstance.exitDataMonitor();
        break;
      case PHASE.DETAILED_FFD:
        this.requirementInstance.getDiagMeasuredData();
        break;
      case PHASE.COMPLETION:
      case PHASE.INTERRUPTION:
      case PHASE.DIAG_CODE_DELETE_FAILURE:
        this.requirementInstance.closeWizard();
        break;
      case PHASE.EVAPO_LEAK_TEST_FAILURE:
      case PHASE.COMMUNICATION_ERROR:
        this.requirementInstance.defaultSessionProcess(0, 0, true, true);
        break;
      case PHASE.FAILED:
        this.requirementInstance.defaultSessionProcess(1, 0, true, true);
        break;
      default:
        break;
    }
  }

}

export default {
  Dialog,
  PHASE
};